export default function Table() {
  return (
    <div className="tw-flex border border-gray-400">
      <div className="w-[280px]">Left</div>
      <div className="righ">Right side</div>
    </div>
  )
}
